// extracted by mini-css-extract-plugin
export default {"pop-up-inner-span":"MapMarkerTrafficPopup_pop-up-inner-span__pbpvL","header":"MapMarkerTrafficPopup_header__7D2bP","mapboxgl-popup":"MapMarkerTrafficPopup_mapboxgl-popup__kV6gf"};